import { useServices } from './useServices';

export const useFilesService = () => {
  return useServices().filesService;
};
